import { MouseEventHandler } from "react";

import { File } from "components/icons/generated";
import DesktopView from "components/Mobile/DesktopView";
import { ButtonProps } from "ds/components/Button";
import LinkButtonIcon from "ds/components/ButtonIcon/LinkButtonIcon";
import { AnalyticsCommonProps } from "hooks/useAnalytics";
import { DocsUrl } from "utils/getDocsUrl";

type LinkTypeProps = {
  href: DocsUrl;
  onClick?: never;
};

type ButtonTypePropsType = {
  href?: never;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

type AllTypesProps = LinkTypeProps | ButtonTypePropsType;

type BaseProps = {
  tooltipText: string;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
} & AnalyticsCommonProps &
  AllTypesProps;

const DocumentationIconButton = ({
  href,
  onClick,
  tooltipText,
  analyticsProps,
  analyticsPage,
  analyticsTitle = "Documentation Clicked",
  size = "medium",
  variant = "secondary",
}: BaseProps) => {
  const hrefProps = href
    ? {
        href,
        target: "_blank",
        rel: "noopener,noreferrer",
      }
    : {};

  return (
    <DesktopView>
      <LinkButtonIcon
        {...hrefProps}
        onClick={onClick}
        size={size}
        variant={variant}
        analyticsPage={analyticsPage}
        analyticsTitle={analyticsTitle}
        analyticsProps={{ target: href, ...analyticsProps }}
        icon={File}
      >
        {tooltipText}
      </LinkButtonIcon>
    </DesktopView>
  );
};

export default DocumentationIconButton;
